import dropdownLists from '@/components/Table/DropdownLists';

export const MESH_DISEASE_CLASS_ID_BY_NAME: Record<string, string> = {
  Infections: 'C01',
  Neoplasms: 'C04',
  'Musculoskeletal Diseases': 'C05',
  'Digestive System Diseases': 'C06',
  'Stomatognathic Diseases': 'C07',
  'Respiratory Tract Diseases': 'C08',
  'Otorhinolaryngologic Diseases': 'C09',
  'Nervous System Diseases': 'C10',
  'Eye Diseases': 'C11',
  'Urogenital Diseases': 'C12',
  'Cardiovascular Diseases': 'C14',
  'Hemic and Lymphatic Diseases': 'C15',
  'Congenital, Hereditary, and Neonatal Diseases and Abnormalities': 'C16',
  'Skin and Connective Tissue Diseases': 'C17',
  'Nutritional and Metabolic Diseases': 'C18',
  'Endocrine System Diseases': 'C19',
  'Immune System Diseases': 'C20',
  'Disorders of Environmental Origin': 'C21',
  'Pathological Conditions, Signs and Symptoms': 'C23',
  'Chemically-Induced Disorders': 'C25',
  'Behavior and Behavior Mechanisms': 'F01',
  'Psychological Phenomena': 'F02',
  'Mental Disorders': 'F03',
  'Behavioral Disciplines and Activities': 'F04',
};

export const normalizeMeshDiseaseClassName = (name: string): string => name.trim();

export const getMeshDiseaseClassOptions = (searchType?: string): string[] => {
  const list =
    searchType === 'VARIANTS' ? dropdownLists.diseaseClassNameMshVda : dropdownLists.diseaseClassNameMshGda;
  return (list as string[]).map(normalizeMeshDiseaseClassName);
};

export const toDiseaseClassIdParam = (names: unknown): string => {
  if (!Array.isArray(names) || names.length === 0) return '';
  const ids = names
    .map(name => {
      const normalized = normalizeMeshDiseaseClassName(String(name ?? ''));
      if (!normalized) return '';
      return MESH_DISEASE_CLASS_ID_BY_NAME[normalized] ?? '';
    })
    .filter(Boolean);
  return [...new Set(ids)].join(',');
};
